import { Button } from '@/components/Elements';
import { Layout } from '@/components/Layout';
import { PRIVATE_TOP_PATH } from '@/routes/private';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface BookmarkLayoutProps {
  totalCount: number;
  children?: React.ReactNode;
}

export const BookmarkLayout: React.FC<BookmarkLayoutProps> = ({
  totalCount,
  children,
}) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <Layout>
      <div className="mx-auto max-w-3xl px-4 py-8">
        <div className="mb-2">
          <Button
            onClick={() => {
              if (window.history.length > 1) {
                navigate(-1);
              } else {
                navigate(PRIVATE_TOP_PATH);
              }
            }}
            color="transparent"
            size="sm"
            startIcon={<ArrowLeftIcon className="size-4" />}
            className="pl-0 text-gray-600 hover:text-gray-800"
          >
            {t('戻る')}
          </Button>
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-semibold lg:text-2xl">
              {t('ブックマーク一覧')}
            </h2>
            <span className="text-base text-gray-600">
              {totalCount} {t('件')}
            </span>
          </div>
        </div>
        <hr className="mb-4" />
        <div className="flex w-full flex-col gap-y-6">{children}</div>
      </div>
    </Layout>
  );
};
